var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFavouriteUnfilled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 16,
    stroke: "white",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1016 12.3895L17.4701 12.7879L17.8686 12.3901C18.9809 11.3061 20.5215 10.8127 22.0355 11.0647C24.3232 11.4458 26 13.4254 26 15.7463V15.9389C26 17.3168 25.4289 18.635 24.4195 19.5746L18.4197 25.176C18.1707 25.4084 17.842 25.5379 17.5 25.5379C17.158 25.5379 16.8293 25.4084 16.5803 25.176L10.5801 19.5746C9.57209 18.635 9 17.3168 9 15.9389V15.7463C9 13.4254 10.6774 11.4458 12.9645 11.0647C14.4486 10.8127 16.0191 11.3061 17.1016 12.3895C17.1016 12.3898 17.0717 12.3895 17.1016 12.3895ZM17.4701 15.0424L15.976 13.4885C15.2555 12.7972 14.2328 12.4692 13.2268 12.6365C11.7077 12.8898 10.5938 14.2057 10.5938 15.7463V15.9389C10.5938 16.8752 10.9826 17.7717 11.6675 18.4092L17.5 23.8545L23.3338 18.4092C24.0178 17.7717 24.4062 16.8752 24.4062 15.9389V15.7463C24.4062 14.2057 23.2906 12.8898 21.7732 12.6365C20.7672 12.4692 19.7445 12.7972 19.024 13.4885L17.4701 15.0424Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavouriteUnfilled);
export default __webpack_public_path__ + "static/media/favourite-unfilled.e41b8e161487f83b7352bccd0d3a9732.svg";
export { ForwardRef as ReactComponent };